import React from 'react';

const GRIDLINE_POSITIONS = [25, 50, 75];

export const StapGridlines: React.FC = () => (
  <>
    {GRIDLINE_POSITIONS.map((position) => (
      <span
        key={position}
        style={{ left: `${position}%` }}
        className="absolute inset-y-0 w-px bg-border-strong/15"
      />
    ))}
  </>
);
